import React, {useEffect, useRef, useState} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {t, getLanguage} from 'react-switch-lang';
import {
  getAllDepartmentType,
  createDepartmentType,
  deleteDepartmentType,
  updateDepartmentType,
} from '../../../services/departmentTypeService';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from './plus.png';
import './DepartmentType.scss';
import {validNameandNumberEngMneRegex} from '../../../utils/const';
import Swal from "sweetalert2";

const DepartmentType =() =>{
    const [departmentType, setDepartmentType]= useState([]);
        const [query, setQuery]= useState();
        const addButton = useRef();

        useEffect(() => {
            const fetchData = async () => {
                try{
                    const {data} = await getAllDepartmentType();
                    setDepartmentType(data);
                }catch (err){}
            };
              fetchData();
        }, []);

        const columns = [
            {
              dataIndex: 'name',
              title: t('departmentType.name'),
              editable: true,
              placeholder: t('departmentType.placeholder.name'),
              rules: [
                {required: true, message: t('message.fieldRequired')},
                {
                  pattern: validNameandNumberEngMneRegex,
                  message: t('message.fieldNotValid'),
                },
                {min: 3, message: t('message.min', {min: 3})},
                {max: 40, message: t('message.max', {max: 40})},
                { whitespace: true,
                  message: t('message.fieldNotValid'),
                },
              ],
            },
            {
              dataIndex: 'nameEn',
              title: t('departmentType.nameEn'),
              editable: true,
              placeholder: t('departmentType.placeholder.nameEn'),
              rules: [
                {required: true, message: t('message.fieldRequired')},
                {
                  pattern: validNameandNumberEngMneRegex,
                  message: t('message.fieldNotValid'),
                },
                {min: 3, message: t('message.min', {min: 3})},
                {max: 40, message: t('message.max', {max: 40})},
                { whitespace: true,
                  message: t('message.fieldNotValid'),
                },
              ],
            },
          ];
        
          const onUpdate = async (data, editingRecord, form) => {
            data.id = editingRecord.id;
            data.nameEn = data.nameEn.trim();
            data.name = data.name.trim();
            try {
              const response = await updateDepartmentType(data);
              if (response.status === 200) {
                Toast.fire({
                  title: t('departmentType.message.updateSuccess', {
                    entity: t('departmentType.departmentType'),
                  }),
                  icon: 'success',
                });
              }
              return response;
            } catch (err) {
              if (err.response.data.detail === 'name') {
                form.setFields([
                  {
                    name: 'name',
                    errors: [t('message.departmentTypeExists')],
                  },
                ]);
              }
              if (err.response.data.detail === 'name_en') {
                form.setFields([
                  {
                    name: 'nameEn',
                    errors: [t('message.departmentTypeExists')],
                  },
                ]);
              }
            }
          };
          const onCreate = async (data, form) => {
            data.nameEn = data.nameEn.trim();
            data.name = data.name.trim();
            try {
              const response = await createDepartmentType(data);
              if (response.status === 201) {
                Toast.fire({
                  title: t('departmentType.message.addSuccess', {
                    entity: t('departmentType.departmentType'),
                  }),
                  icon: 'success',
                });
              }
              return response;
            } catch (err) {
              if (err.response.data.detail === 'name') {
                form.setFields([
                  {
                    name: 'name',
                    errors: [t('message.departmentTypeExists')],
                  },
                ]);
              }
              if (err.response.data.detail === 'name_en') {
                form.setFields([
                  {
                    name: 'nameEn',
                    errors: [t('message.departmentTypeExists')],
                  },
                ]);
              }
            }
          };
        
          const onDelete = async (record) => {
            return new Promise((resolve, reject) => {
              Prompt.fire({
                title: t('title.deleteDepartmentType'),
                text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
                confirmButtonText: t('common.delete').toUpperCase(),
                cancelButtonText: t('common.cancel').toUpperCase(),
                preConfirm: async () => {
                  try {
                    const response = await deleteDepartmentType(record.id);
                    if (response.status === 204) {
                      Toast.fire({
                        title: t('departmentType.message.deleteSuccess', {
                          entity: t('departmentType.departmentType'),
                        }),
                        icon: 'success',
                      });
                      resolve(response);
                    } else {
                      reject(response);
                    }
                  } catch (err) {
                    Swal.fire({
                        text: `${t('message.errorDeleteDepartmentType')}`,
                        icon: 'error',
                        confirmButtonText: 'OK',
                      });
                  }
                },
              });
            });
          };
        
          return (
            <div className="users administration-template">
              <div className="w-40 d-flex justify-content-between mb-4">
                <div className="search-field">
                  <SearchBox
                    placeholder={t('departmentType.placeholder.search')}
                    setQuery={setQuery}
                  />
                </div>
                <div className="button-add">
                  <button className="btn btn-primary" ref={addButton}>
                    <img src={AddIcon} alt="" />
                    <p> {t('departmentType.add')}</p>
                  </button>
                </div>
              </div>
              <CustomTable
                api="/department-types"
                query={query}
                sort={getLanguage() === "eng" ? "nameEn" : "name"}
                queryParamName="name.contains"
                columns={columns}
                methods={{onUpdate, onDelete, onCreate}}
                addButtonRef={addButton}
              />
            </div>
          );
        };


export default DepartmentType;